export function getFilePreviewUrl(url, contentType, size = 512) {
    if (!url || !contentType) {
        return undefined;
    }
    if (contentType.startsWith('image/')) {
        if (url.startsWith('blob:')) {
            // Locally cached files
            return url;
        }
        return getFileImagePreviewUrl(url, size);
    }
    return undefined;
}
export function getFileImagePreviewUrl(url, size) {
    return url + `&w=${size}`;
}
//# sourceMappingURL=getFilePreviewUrl.js.map